import { logger } from '@/lib';

export const logResidentialAddressEditToFPTI = (): void => {
  logger.fpti('residential_address_edit_clicked', {
    state_name: 'billing',
    transition_name: 'residential_address_edit_clicked',
  });
};
